import {Button, Form, InputNumber, Row, Select, Slider, Switch, Tag} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import IconPicker from "../../../../../shared/IconPicker";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import {IAppState} from "../../../../../../redux/store";
import selectors from "../../../../../../redux/selectors";
import {connect} from "react-redux";
import TranslationInput from "../../../../../shared/input/TranslationInput";
import {MenuOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import DragSortList from "../../../../../shared/list/DragsortList";
import Utils from "../../../../../../utils";
import FilePicker from "../../../../../shared/pickers/file/FilePicker";
import Wysiwyg from "../../../../../shared/input/Wysiwyg";
import {IFileThumbnailMinimum} from "../../../../../../model/interface/file/IFile";

export interface IFieldRatingOptions {
    rateType?: FieldRatingType
    rateIcon?: string
    rateLength?: number
    rateImages?: IFileThumbnailMinimum[]
    rateImageHeight?: number
    rateTexts?: string[]
    rateDisplayValue?: boolean
}

export type FieldRatingType = 'icon' | 'image' | 'text'

interface IProps extends IFieldOptionsEditorProps {
    getText: (code: string, fallBack?: string) => string
}

class FieldRateOptionsEditor extends React.Component<IProps> {

    render() {
        const {options, buildFieldName, getText} = this.props


        console.log(options)

        return (
            <div>
                <Form.Item name={buildFieldName('rateType')} initialValue={'icon'}
                           label={<LocaleText code={'configuration.field.rating.type'} fallback={'Typ'}/>}>
                    <Select>
                        <Select.Option value={'icon'}>
                            <LocaleText code={'configuration.field.rating.type.icon'} fallback={'Ikona'}/>
                        </Select.Option>
                        <Select.Option value={'image'}>
                            <LocaleText code={'configuration.field.rating.type.image'} fallback={'Obrázek'}/>
                        </Select.Option>
                        <Select.Option value={'text'}>
                            <LocaleText code={'configuration.field.rating.type.text'} fallback={'Text'}/>
                        </Select.Option>
                    </Select>
                </Form.Item>
                {
                    {
                        icon: <div>
                            <Form.Item name={buildFieldName('rateIcon')} label={<LocaleText code={'configuration.field.rating.icon'} fallback={'Zvolte iconu'}/>}>
                                <IconPicker/>
                            </Form.Item>
                            <Form.Item name={buildFieldName('rateLength')} label={<LocaleText code={'configuration.field.rating.length'} fallback={'Zvolte počet bodů'}/>} rules={[{required: true}]}
                                       initialValue={5}>
                                <Slider min={1} max={10}/>
                            </Form.Item>
                        </div>,
                        image: <div>
                            <Form.Item label={<LocaleText code={'configuration.field.rating.images'}
                                                          fallback={'Obrázky'}/>}>
                                <Form.List name={buildFieldName('rateImages')} rules={[
                                    {
                                        validator: async (_, value) => {
                                            if (!value || value.length === 0) {
                                                return Promise.reject(new Error(getText('form.item.required')));
                                            }
                                            return Promise.resolve();
                                        },
                                    }
                                ]}>
                                    {(fields, {add, remove, move}) => (
                                        <div>
                                            <DragSortList
                                                children={fields}
                                                identifier="key"
                                                lockAxis="y"
                                                useDragHandle={true}
                                                showEmpty={false}
                                                onSortEnd={({oldIndex, newIndex}) => {
                                                    move(oldIndex, newIndex);
                                                }}
                                                item={{
                                                    render: (field, index, dragHandle) => (
                                                        <div key={field.key} style={{marginBottom: '12px'}}>
                                                            <Row align={'middle'}>
                                                                <div className="mr-3">
                                                                    {dragHandle}
                                                                </div>
                                                                <Tag className={'mr-2'}>{index + 1}</Tag>
                                                                <Form.Item
                                                                    {...field}
                                                                    validateTrigger={['onChangeMinimum', 'onBlur']}
                                                                    trigger={'onChangeThumbnailMinimum'}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: <LocaleText
                                                                                code={'configuration.field.rating.images.required'}
                                                                                fallback={'Nahrajte obrázek nebo odstraňte toto pole'}/>,
                                                                        },
                                                                    ]}
                                                                >
                                                                    <FilePicker canChoose={false} widget={"image"}/>
                                                                </Form.Item>

                                                                {fields.length > 1 ? (
                                                                    <MinusCircleOutlined
                                                                        className="dynamic-delete-button ml-2"
                                                                        onClick={() => remove(field.name)}
                                                                    />
                                                                ) : null}
                                                            </Row>
                                                        </div>
                                                    )
                                                }}
                                                handle={{
                                                    render: () => <MenuOutlined
                                                        style={{color: '#999', cursor: 'grab'}}/>
                                                }}
                                            />

                                            <Button size={'small'} type="dashed" onClick={() => add()}>
                                                <PlusOutlined/>
                                            </Button>
                                        </div>
                                    )}
                                </Form.List>
                            </Form.Item>
                            <Form.Item name={buildFieldName('rateImageHeight')} label={'Výška obrázku'}
                                       rules={[{required: true}]}
                                       initialValue={50}>
                                <InputNumber/>
                            </Form.Item>
                        </div>,
                        text: <div>
                            <Form.Item label={<LocaleText code={'configuration.field.rating.texts'}
                                                          fallback={'Možnosti'}/>}>
                                <Form.List name={buildFieldName('rateTexts')} rules={[
                                    {
                                        validator: async (_, value) => {
                                            if (!value || value.length === 0) {
                                                return Promise.reject(new Error(getText('form.item.required')));
                                            }
                                            return Promise.resolve();
                                        },
                                    }
                                ]}>
                                    {(fields, {add, remove, move}) => (
                                        <div>
                                            <DragSortList
                                                children={fields}
                                                identifier="key"
                                                lockAxis="y"
                                                useDragHandle={true}
                                                showEmpty={false}
                                                onSortEnd={({oldIndex, newIndex}) => {
                                                    move(oldIndex, newIndex);
                                                }}
                                                item={{
                                                    render: (field, index, dragHandle) => (
                                                        <Form.Item required={false} key={field.key}
                                                                   style={{marginBottom: '12px'}}>
                                                            <Row align={'middle'}>
                                                                <div className="mr-3">
                                                                    {dragHandle}
                                                                </div>
                                                                <Tag className={'mr-2'}>{index + 1}</Tag>
                                                                <Form.Item
                                                                    {...field}
                                                                    validateTrigger={['onChange', 'onBlur']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            whitespace: true,
                                                                            message: <LocaleText
                                                                                code={'configuration.field.rating.images.required'}
                                                                                fallback={'Zadejte název možnosti nebo toto pole smažte.'}/>,
                                                                        },
                                                                    ]}
                                                                    noStyle
                                                                >
                                                                    <TranslationInput  code={'configuration.field.rating.texts.value.' + Utils.uuid()}
                                                                                      preserveCode={true} customInput={(value, triggerSave, onChange, className) =>
                                                                        <Wysiwyg mode={"full"} onSubmit={triggerSave}
                                                                                 value={value}
                                                                                 onChange={onChange}
                                                                                 className={className}/>}/>
                                                                </Form.Item>

                                                                {fields.length > 1 ? (
                                                                    <MinusCircleOutlined
                                                                        className="dynamic-delete-button ml-2"
                                                                        onClick={() => remove(field.name)}
                                                                    />
                                                                ) : null}
                                                            </Row>
                                                        </Form.Item>
                                                    )
                                                }}
                                                handle={{
                                                    render: () => <MenuOutlined
                                                        style={{color: '#999', cursor: 'grab'}}/>
                                                }}
                                            />
                                                <Button type="dashed" onClick={() => add()}>
                                                    <PlusOutlined/>
                                                </Button>
                                        </div>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </div>
                    }[options.rateType || 'icon']
                }
                <Form.Item name={buildFieldName('rateDisplayValue')} label={'Zobrazit hodnotu'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
            </div>
        )
    }
}


const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    };
};

export default connect(mapStateToProps)(FieldRateOptionsEditor);